import { FormDefaultAttributes } from '@common';
import DecisionSupportWizardApplyPrice from '../components/wizard/DecisionSupportWizardApplyPrice.vue';

export const DECISION_SUPPORT_WIZARD_APPLY_PRICES_FORM_CONFIG = {
  name: 'decisionSupportWizardApplyPricesForm',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes()
  },
  children: [
    {
      name: 'upkeepCost',
      component: 'text',
      attributes: {
        type: 'number',
        label: 'decisionSupport.wizard.label.generalUpkeepCost',
        suffix: 'Ft/ha',
        hideDetails: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 12
        },
        mask: {
          mask: /^[1-9]\d*/
        },
        appendComponent: DecisionSupportWizardApplyPrice
      },

      filters: [
        {
          filter: 'integer',
          settings: {
            min: 0
          }
        }
      ]
    },
    {
      name: 'cropPrice',
      component: 'text',
      attributes: {
        type: 'number',
        label: 'decisionSupport.wizard.label.cropPrice',
        suffix: 'Ft/t',
        hideDetails: true
      },
      settings: {
        needTranslate: true,
        grid: {
          cols: 12,
          md: 12
        },
        mask: {
          mask: /^[1-9]\d*/
        },
        appendComponent: DecisionSupportWizardApplyPrice
      },
      filters: [
        {
          filter: 'integer',
          settings: {
            min: 0
          }
        }
      ]
    }
  ]
};
